module.exports = __webpack_public_path__ + "static/media/snow.e02a1452.png";